export const emojiFlags = {
    US: {
        unicode: '0x1F1FA-0x1F1F8', // 1F1FA 1F1F8
        description: 'Flag of the United States'
    },
    COM: {
        unicode: '0x1F1FA-0x1F1F8', // 1F1FA 1F1F8
        description: 'Flag of the United States'
    },
    FR: {
        unicode: '0x1F1EB-0x1F1F7', // 1F1EB 1F1F7
        description: 'Flag of France'
    },
    IT: {
        unicode: '0x1F1EE-0x1F1F9', // 1F1EE 1F1F9
        description: 'Flag of Italy'
    },
    ES: {
        unicode: '0x1F1EA-0x1F1F8', // 1F1EA 1F1F8
        description: 'Flag of Spain'
    },
    DE: {
        unicode: '0x1F1E9-0x1F1EA', // 1F1E9 1F1EA
        description: 'Flag of Germany'
    },
    JP: {
        unicode: '0x1F1EF-0x1F1F5', // 1F1EF 1F1F5
        description: 'Flag of Japan'
    },
    UK: {
        unicode: '0x1F1EC-0x1F1E7', // 1F1EC 1F1E7
        description: 'Flag of the United Kingdom'
    },
    "CO.UK": {
        unicode: '0x1F1EC-0x1F1E7', // 1F1EC 1F1E7
        description: 'Flag of the United Kingdom'
    },
    DEFAULT: {
        unicode: '0x1F60A', // 1F1FA 1F1F8
        description: 'default emoji'
    }
};

export const DEFAULT_FLAG = {
    unicode: '0x1F60A', // 1F1FA 1F1F8
    description: 'default emoji'
}
